import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

// Definitions (Master Checklist)
async function getDefinitions(params?: any) {
  const response = await http
    .getDataParam("/laundry/supervisi/definitions", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Sessions (Supervisi)
async function getList(params?: any) {
  const response = await http
    .getDataParam("/laundry/supervisi/sessions", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/laundry/supervisi/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/laundry/supervisi/sessions", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/laundry/supervisi/sessions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/laundry/supervisi/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Submit & Save final items
async function submit(id: number, data: any) {
  const response = await http
    .postData(`/laundry/supervisi/sessions/${id}/submit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Signing
async function signSupervisor(id: number, data: { password: string }) {
  const response = await http
    .postData(`/laundry/supervisi/sessions/${id}/sign-supervisor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function acknowledge(id: number, data: { password: string }) {
  const response = await http
    .postData(`/laundry/supervisi/sessions/${id}/acknowledge`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Tindak Lanjut
async function updateTindakLanjut(sessionId: number, itemId: number, data: any) {
  const response = await http
    .putData(`/laundry/supervisi/sessions/${sessionId}/items/${itemId}/tindak-lanjut`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getTemuanTerbuka(params?: any) {
  const response = await http
    .getDataParam("/laundry/supervisi/temuan-terbuka", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Dashboard
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam("/laundry/supervisi/dashboard", params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Upload Foto Bukti
async function uploadFotoBukti(file: File) {
  const form = new FormData();
  form.append("file", file);
  const response = await http
    .postData("/laundry/supervisi/upload-foto", form)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/laundry/supervisi/sessions/${id}/pdf`,
    "_blank"
  );
}

export default {
  getDefinitions,
  getList,
  find,
  create,
  update,
  destroy,
  submit,
  signSupervisor,
  acknowledge,
  updateTindakLanjut,
  getTemuanTerbuka,
  getDashboard,
  uploadFotoBukti,
  printPdf,
};
